import React, { useEffect, useRef } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { getRegion, REGIONS } from '../data/regions';

const { FiX, FiLock, FiCheck } = FiIcons;

const weekdays = [
  [1, 'Montag', 'Mo'],
  [2, 'Dienstag', 'Di'],
  [3, 'Mittwoch', 'Mi'],
  [4, 'Donnerstag', 'Do'],
  [5, 'Freitag', 'Fr']
];

function SettingsDialog({ open, settings, onChange, onClose }) {
  const dialogRef = useRef(null);

  useEffect(() => {
    if (open) dialogRef.current?.focus();
  }, [open]);

  if (!open) return null;

  const selectedRegion = getRegion(settings.regionId);

  const toggleDay = (day) => {
    const selected = settings.workdays.includes(day);
    const workdays = selected
      ? settings.workdays.filter((value) => value !== day)
      : [...settings.workdays, day].sort();

    onChange({ ...settings, workdays });
  };

  return (
    <div
      className="dialog-backdrop"
      role="presentation"
      onMouseDown={onClose}
    >
      <section
        className="settings-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="settings-title"
        tabIndex="-1"
        ref={dialogRef}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <button
          className="icon-button dialog-close"
          type="button"
          onClick={onClose}
          aria-label="Einstellungen schließen"
        >
          <SafeIcon icon={FiX} />
        </button>

        <p className="section-kicker">Deine persönliche Übersicht</p>
        <h2 id="settings-title">Arbeitstage einstellen</h2>
        <p>
          Wähle dein Bundesland und deine regulären Arbeitstage aus.
          Die Ferientermine und der Countdown werden entsprechend angepasst.
        </p>

        <label className="field-label" htmlFor="region">
          Bundesland
        </label>
        <select
          id="region"
          value={settings.regionId}
          onChange={(event) => onChange({
            ...settings,
            regionId: event.target.value
          })}
        >
          {REGIONS.map((region) => (
            <option value={region.id} key={region.id}>
              {region.name}
            </option>
          ))}
        </select>
        <p className="region-hint">
          {selectedRegion.name}: {selectedRegion.movingDays} bewegliche Ferientage
          laut Übersicht 2026/2027.
        </p>

        <label className="field-label" htmlFor="first-name">
          Vorname <span>optional</span>
        </label>
        <input
          id="first-name"
          type="text"
          maxLength="40"
          value={settings.firstName}
          onChange={(event) => onChange({
            ...settings,
            firstName: event.target.value
          })}
          placeholder="Wie dürfen wir dich begrüßen?"
        />

        <fieldset>
          <legend>Deine regulären Arbeitstage</legend>
          <div className="weekday-grid">
            {weekdays.map(([value, label, short]) => {
              const selected = settings.workdays.includes(value);

              return (
                <button
                  className={`weekday-button ${selected ? 'selected' : ''}`}
                  type="button"
                  key={value}
                  onClick={() => toggleDay(value)}
                  aria-pressed={selected}
                  aria-label={label}
                >
                  {selected && <SafeIcon icon={FiCheck} aria-hidden="true" />}
                  <span>{short}</span>
                </button>
              );
            })}
          </div>
        </fieldset>

        <div className="privacy-note">
          <SafeIcon icon={FiLock} aria-hidden="true" />
          <p>
            <strong>Privat auf deinem Gerät:</strong> Bundesland, Vorname und
            Arbeitstage werden nur auf diesem Gerät gespeichert.
          </p>
        </div>

        <button
          className="button button-primary save-button"
          type="button"
          onClick={onClose}
        >
          Auswahl übernehmen
        </button>
      </section>
    </div>
  );
}

export default SettingsDialog;